import React from 'react'
import { useSelector } from 'react-redux'
import { Typography, TypographyTypes } from 'rds'
import { getPictureThumbnail } from '../utils/file'
import { LOGO_DEFAULT_HEIGHT } from '../constants'

const Logo = () => {
    const projectName = useSelector(
        state => state.session.subscription.projectFullname,
    )
    const webstoreSettingsHeader = useSelector(
        state => state.session.subscription.webstore.settings.header,
    )
    return webstoreSettingsHeader.logo.url ? (
        <img
            className='nav_logo'
            height={webstoreSettingsHeader.logo.height || LOGO_DEFAULT_HEIGHT}
            width={webstoreSettingsHeader.logo.width}
            src={getPictureThumbnail(
                webstoreSettingsHeader.logo.url,
                webstoreSettingsHeader.logo.width,
                webstoreSettingsHeader.logo.height || LOGO_DEFAULT_HEIGHT,
            )}
            alt={projectName}
        />
    ) : (
        <Typography
            style={{ fontWeight: 'bolder' }}
            variant={webstoreSettingsHeader.text.variant}
            type={TypographyTypes.H2}
        >
            {projectName}
        </Typography>
    )
}

export default Logo
